<template>
  <div  class="app-container">
    <!--标题-->
    <el-tabs v-model="editableTabsValue" @tab-click="handleClick">
      <el-tab-pane :key="index" v-for="(item, index) in editableTabs" :label="item.feeName" :name="item.id + ''">
        <!--查询条件-->
        <div class="formBox margbot" ref="searchBox">
          <el-form :inline="true" :model="searchFrom1" ref="searchFrom1" class="demo-form-inline" label-width="100px" size="mini" style="width: 100%;">
            <div class=" formItemBox" v-if="ext1Show!='1'&&ext1Show!='3'">
              <el-form-item label="适用类型:" prop="default_flg ">
                <el-select filterable v-model="searchFrom1.default_flg " size="mini" placeholder="请选择" clearable>
                  <el-option v-for="item in TypesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="适用客户:" prop="default_code">
                <el-select filterable v-model="searchFrom1.default_code" @change="keHuChange" :validate-event="false" placeholder="请选择">
                  <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:" prop="productType_value " v-if="ext1Show!='2'">
                <el-select filterable v-model="searchFrom1.productType_value" size="mini" placeholder="请选择" clearable>
                  <el-option v-for="(item, index) in HwOptions" :key="index" :label="item.show_name" :value="item.item_no"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-if="ext1Show=='1'" class=" formItemBox">
              <el-form-item label="适用类型:" prop="default_flg ">
                <el-select filterable v-model="searchFrom1.default_flg " size="mini" placeholder="请选择" clearable>
                  <el-option v-for="item in TypesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="一级货主:" prop="primaryCustomerCode">
                <el-select filterable v-model="searchFrom2.primaryCustomerCode" :validate-event="false" placeholder="请选择">
                  <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级货主:" prop="default_code">
                <el-select filterable v-model="searchFrom1.default_code" @change="keHuChange" :validate-event="false" placeholder="请选择">
                  <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>

            </div>
            <div v-if="ext1Show=='3'" class=" formItemBox">
              <el-form-item label="适用类型:" prop="default_flg ">
                <el-select filterable v-model="searchFrom1.default_flg " size="mini" placeholder="请选择" clearable>
                  <el-option v-for="item in TypesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算客户:" prop="primaryCustomerCode">
                <el-select filterable v-model="searchFrom1.default_code" @change="keHuChange" :validate-event="false" placeholder="请选择">
                  <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:" prop="productType_value ">
                <el-select filterable v-model="searchFrom1.productType_value" size="mini" placeholder="请选择" clearable>
                  <el-option v-for="(item, index) in HwOptions" :key="index" :label="item.show_name" :value="item.item_no"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="searchBtnBox">
              <el-form-item>
                <el-button type="primary" @click="searchClick" btnCode='000P00PB001' v-if="btnFlg[0]">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetClick" btnCode='000P00PB002' v-if="btnFlg[1]">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addBtnClick" btnCode='000P00PB003' v-if="btnFlg[2]">新增</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="changeBtnClick" btnCode='000P00PB004' v-if="btnFlg[3]">修改</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="delBtnClick" btnCode='000P00PB005' v-if="btnFlg[4]">删除</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="seeBtnClick" btnCode='000P00PB006' v-if="btnFlg[5]">查看规则</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <!--  表格 -->
        <div class="table" :style="{height:h}">
          <el-table :data="tableDate" ref="tableRef" border bordersize="mini" height="100%" style="width: 100%;margin-top:10px;" center @row-click="dianjixuanzhong" @current-change="handleTabCurrentChange" :header-cell-style="{background:'#F5F5F5',color:'black'}" :header-row-style="{height:'45px'}" :row-style="{height:'35px'}" highlight-current-row>
            <el-table-column v-for="(item,index) in tableHeardArr" class="tableComent" :key="index" :prop="item.attrStandard" :label="item.attrName">
              <!-- if（interControl=2||interControl=4 ）显示用attrStandard 截取掉（-value） -->
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 10,25,50,100-->
        <div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchFrom1.pageNo" :page-sizes="[10,25,50,100]" :page-size="searchFrom1.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!--新增-->
      <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addDialog" width="750px" center>
        <span>
          <el-form :model="addFrom" ref="addFrom" :rules="rules" :validate-on-rule-change="false" class="demo-form-inline" label-width="260px" size="mini">

            <!-- 客户 -->
            <el-form-item label="适用标识" prop='biaoShi' style="margin-top:20px;">
              <el-radio-group :disabled="disRadio" v-model="addFrom.biaoShi" @change="radioChange">
                <el-radio :label="1">通用</el-radio>
                <el-radio :label="0">非通用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="erJiKehu" label="一级货主" prop='primaryCustomerCode' :rules="[
            { required: true, message: '一级货主不能为空', trigger: 'blur' },
          ]" style="margin-top:20px;">
              <el-select filterable :disabled="disSelectKh" v-model="addFrom.primaryCustomerCode" @change="primaryCustomerCodeChange" :validate-event="false" placeholder="请选择" style="width:210px;">
                <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="erJiKehu" label="二级货主" prop='suoShuKeHu' :rules="[
            { required: true, message: '二级货主不能为空', trigger: 'blur' },
          ]" style="margin-top:20px;">
              <el-select filterable :disabled="disSelectKh" v-model="addFrom.suoShuKeHu" @change="keHuChange" :validate-event="false" placeholder="请选择" style="width:210px;">
                <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="disKehu" label="所属客户" prop='suoShuKeHu' style="margin-top:20px;">
              <el-select filterable :disabled="disSelectKh" v-model="addFrom.suoShuKeHu" @change="keHuChange" :validate-event="false" placeholder="请选择" style="width:210px;">
                <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="addinpBox" v-for="(item,index) in addFrom.addDataList" :key="index">
              <!-- 文本框 有校验-->
              <el-form-item :label="item.attrName.indexOf('(')==-1?item.attrName:item.attrName.substring(0,item.attrName.indexOf('('))" v-if="(item.interControl == '1' && item.isnotFlg == '0') && (item.attrStandard != 'primaryCustomerFlag_value') && (item.attrStandard != 'ladderFeeFlag_value')" :prop="'addDataList.' + index + '.ext3'" :key="index" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'change' },
                ]" style="margin-top:20px;">
                <el-input v-if='item.attrDatatype==1' v-number-input.float='0' v-model="item.ext3" style="width:210px;" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>
                </el-input>
                <el-input v-else-if='item.attrDatatype==2' v-model="item.ext3" v-number-input.float="item.attrLength.slice(-1)" style="width:210px;" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>
                  <i v-if="radioJiaoyan!=''&&item.attrName.indexOf('(')==-1" slot="suffix">{{radioJiaoyan=='1'?'元/次':radioJiaoyan=='2'?'元/吨':radioJiaoyan=='3'?'元/件':''}}</i>
                </el-input>
                <el-input v-else-if='item.attrDatatype==3' v-model="item.ext3" style="width:210px;" v-number-input.float="item.attrLength.slice(-1)" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>

                </el-input>
              </el-form-item>
              <!-- 文本框 无校验-->
              <el-form-item :label="item.attrName.indexOf('(')==-1?item.attrName:item.attrName.substring(0,item.attrName.indexOf('('))" v-if="item.interControl == '1' && item.isnotFlg == '1'" style="margin-top:20px;">
                <!-- <el-input v-model="item.ext3" style="width:210px;" :validate-event="false"></el-input> -->
                <el-input v-if='item.attrDatatype==1' v-number-input.float='0' v-model="item.ext3" style="width:210px;" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>
                </el-input>
                <el-input v-else-if='item.attrDatatype==2' v-model="item.ext3" v-number-input.float="item.attrLength.slice(-1)" style="width:210px;" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>
                  <i v-if="radioJiaoyan!=''&&item.attrName.indexOf('(')==-1" slot="suffix">{{radioJiaoyan=='1'?'元/次':radioJiaoyan=='2'?'元/吨':radioJiaoyan=='3'?'元/件':''}}</i>
                </el-input>
                <el-input v-else-if='item.attrDatatype==3' v-model="item.ext3" style="width:210px;" v-number-input.float="item.attrLength.slice(-1)" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>

                </el-input>
              </el-form-item>
              <!-- 下拉框 有校验-->
              <el-form-item :id="item.id" :label="item.attrName" v-if="item.interControl == '2'  && item.isnotFlg == '0'" :prop="'addDataList.' + index + '.ext3'" :key="index" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'change' },
                ]" style="margin-top:20px;">
                <el-select filterable :disabled='item.attrStandard=="pricingMethod_value"?false:item.attrStandard=="billingStartDate_value"?false:disEdit' v-model="item.ext3" @change="selectChange(item.id)" :validate-event="false" placeholder="请选择" style="width:210px;">
                  <span v-for="(i,index) in item.codeOptions" :key="index">
                    <el-option :label="i.show_name" :value="i.item_no">
                    </el-option>
                  </span>
                </el-select>
              </el-form-item>
              <!-- 下拉框 无校验-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '2'  && item.isnotFlg == '1'" style="margin-top:20px;">
                <el-select filterable v-model="item.ext3" @change="selectChange2(item.id)" :validate-event="false" placeholder="请选择" style="width:210px;">
                  <span v-for="(i,index) in item.codeOptions2" :key="index">
                    <el-option :label="i.show_name" :value="i.item_no">
                    </el-option>
                  </span>
                </el-select>
              </el-form-item>
              <!-- 日期 有校验-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '3'  && item.isnotFlg == '0'" :prop="'addDataList.' + index + '.ext3'" :key="index" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'blur' },
                ]" style="margin-top:20px;">
                <el-date-picker placeholder="选择日期" style="width:210px;" v-model="item.ext3" type="date" :validate-event="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <!-- 日期 无校验-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '3'  && item.isnotFlg == '1'" style="margin-top:20px;">
                <el-date-picker placeholder="选择日期" style="width:210px;" v-model="item.ext3" type="date" :validate-event="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <!-- 复选框 有校验"-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '4'  && item.isnotFlg == '0'" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'change' },
                ]" prop="checkDataArr" style="margin-top:20px;">
                <el-checkbox-group v-model="checkDataArr">
                  <el-checkbox :validate-event="false" v-for="i in checkData" :key="i.item_no" :label="i.show_name" :value="i.item_no" :checked="checkedFlg" @change="checkChange(i,$event)"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <!-- 复选框 无校验-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '4'  && item.isnotFlg == '1'" style="margin-top:20px;">
                <el-checkbox-group v-model="checkDataArr">
                  <el-checkbox :validate-event="false" v-for="(i,index) in checkData" :key="index" :label="i.item_no" :checked="checkedFlg" @change="checkChange(i,$event)">{{i.showName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <!-- 单选框 有校验"-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '5'  && item.isnotFlg == '0'" :prop="'addDataList.' + index + '.ext3'" style="margin-top:20px;" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'change' },
                ]">
                <el-radio-group v-model="item.ext3" @change="(val)=>{radioChagejiaoyan(val,item)}">
                  <el-radio :validate-event="false" v-for="i in radioData" :key="i.item_no" :label="i.item_no">{{i.show_name}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 单选框 无校验"-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '5'  && item.isnotFlg == '1'" :prop="'addDataList.' + index + '.ext3'" style="margin-top:20px;">
                <el-radio-group v-model="item.ext3">
                  <el-radio :validate-event="false" v-for="i in radioData" :key="i.item_no" :label="i.item_no">{{i.show_name}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>

            <div style="margin:20px 0 0 190px;" v-if="jieTiShow">
              <div style="margin: 0 0 20px 0;">
                <el-button type="primary" @click="jieTiAdd" size="mini">添加费率</el-button>
              </div>
              <el-table size="mini" border bordersize="mini" ref="tableList" :data="tableList" style="width:473px;font-size:13px;" :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" :header-cell-style="{background:'#F5F5F5',color:'black'}">
                <el-table-column prop="ladderType" label="阶梯" width="60px">
                  <template slot-scope="scope">
                    <span>{{scope.$index + 1}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="startDays" label="开始天数" width="100px">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.startDays" v-number-input.float="0" maxlength="5" placeholder="请输入" disabled size="mini"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="endDays" label="结束天数" width="100px">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.endDays" v-number-input.float="0" maxlength="5" placeholder="请输入" size="mini" @blur="changeEndDays(scope.row,scope.$index)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="ladderUnitPrice" label="单价(元/吨·天)" width="142px">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.ladderUnitPrice" v-number-input.float="2" maxlength="10" placeholder="请输入" size="mini"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="操作" width="70px">
                  <template v-slot="scope">
                    <el-button type="text" :disabled='scope.$index == 0' @click="deleteBtn(scope.row,scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size='mini' @click="addSubmit('addFrom')" :loading='addLoading' v-if="addBtnShow">保存</el-button>
          <el-button type="primary" size='mini' @click="changeSubmit('addFrom')" :loading='changeLoading' v-if="changeBtnShow">修改</el-button>
          <el-button @click="addSpuClose('addFrom')" size='mini'>取 消</el-button>
        </span>
      </el-dialog>
      <!-- 查看 -->
      <el-dialog title="查看" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="seeDialog" width="750px" center>
        <span>
          <el-form :model="addFrom" ref="addFrom" :rules="rules" :validate-on-rule-change="false" class="demo-form-inline" label-width="260px" size="mini">
            <div class="addinpBox" v-for="(item,index) in addFrom.addDataList" :key="index">
              <!-- 文本框 有校验-->
              <el-form-item :label="item.attrName.indexOf('(')==-1?item.attrName:item.attrName.substring(0,item.attrName.indexOf('('))" v-if="(item.interControl == '1' && item.isnotFlg == '0') && (item.attrStandard != 'primaryCustomerFlag_value') && (item.attrStandard != 'ladderFeeFlag_value')" :prop="'addDataList.' + index + '.ext3'" :key="index" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'blur' },
                ]" style="margin-top:20px;">
                <el-input v-if='item.attrDatatype==1' disabled v-number-input.float='0' v-model="item.ext3" style="width:210px;" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>
                </el-input>
                <el-input v-else-if='item.attrDatatype==2' disabled v-model="item.ext3" v-number-input.float="item.attrLength.slice(-1)" style="width:210px;" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>
                </el-input>
                <el-input v-else-if='item.attrDatatype==3' disabled v-model="item.ext3" style="width:210px;" v-number-input.float="item.attrLength.slice(-1)" :validate-event="false">
                  <i v-if="item.attrName.indexOf('(')!=-1" slot="suffix">{{item.attrName.substring(item.attrName.indexOf('(')+1,item.attrName.length-1)}}</i>
                </el-input>
              </el-form-item>
              <!-- 文本框 无校验-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '1' && item.isnotFlg == '1'" style="margin-top:20px;">
                <el-input v-model="item.ext3" disabled style="width:210px;" :validate-event="false"></el-input>
              </el-form-item>
              <!-- 下拉框 有校验-->
              <el-form-item :id="item.id" :label="item.attrName" v-if="item.interControl == '2'  && item.isnotFlg == '0'" :prop="'addDataList.' + index + '.ext3'" :key="index" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'change' },
                ]" style="margin-top:20px;">
                <el-select filterable disabled v-model="item.ext3" @change="selectChange(item.id)" :validate-event="false" placeholder="请选择" style="width:210px;">
                  <span v-for="(i,index) in item.codeOptions" :key="index">
                    <el-option :label="i.show_name" :value="i.item_no">
                    </el-option>
                  </span>
                </el-select>
              </el-form-item>
              <!-- 下拉框 无校验-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '2'  && item.isnotFlg == '1'" style="margin-top:20px;">
                <el-select filterable disabled v-model="item.ext3" @change="selectChange2(item.id)" :validate-event="false" placeholder="请选择" style="width:210px;">
                  <span v-for="(i,index) in item.codeOptions2" :key="index">
                    <el-option :label="i.show_name" :value="i.item_no">
                    </el-option>
                  </span>
                </el-select>
              </el-form-item>
              <!-- 日期 有校验-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '3'  && item.isnotFlg == '0'" :prop="'addDataList.' + index + '.ext3'" :key="index" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'blur' },
                ]" style="margin-top:20px;">
                <el-date-picker disabled placeholder="选择日期" style="width:210px;" v-model="item.ext3" type="date" :validate-event="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <!-- 日期 无校验-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '3'  && item.isnotFlg == '1'" style="margin-top:20px;">
                <el-date-picker disabled placeholder="选择日期" style="width:210px;" v-model="item.ext3" type="date" :validate-event="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <!-- 复选框 有校验"-->
              <el-form-item :label="item.attrName" disabled v-if="item.interControl == '4'  && item.isnotFlg == '0'" prop="checkDataArr" style="margin-top:20px;">
                <el-checkbox-group v-model="checkDataArr">
                  <el-checkbox :validate-event="false" v-for="i in checkData" :key="i.item_no" :label="i.show_name" :value="i.item_no" :checked="checkedFlg" @change="checkChange(i,$event)"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <!-- 复选框 无校验-->
              <el-form-item :label="item.attrName" disabled v-if="item.interControl == '4'  && item.isnotFlg == '1'" style="margin-top:20px;">
                <el-checkbox-group v-model="checkDataArr">
                  <el-checkbox :validate-event="false" v-for="(i,index) in checkData" :key="index" :label="i.item_no" :checked="checkedFlg" @change="checkChange(i,$event)">{{i.showName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <!-- 单选框 有校验"-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '5'  && item.isnotFlg == '0'" :prop="'addDataList.' + index + '.ext3'" style="margin-top:20px;" :rules="[
                  { required: true, message: '此项不能为空', trigger: 'blur' },
                ]">
                <el-radio-group v-model="item.ext3" @change="(val)=>{radioChagejiaoyan(val,item)}">
                  <el-radio :validate-event="false" v-for="i in radioData" :key="i.item_no" :label="i.item_no">{{i.show_name}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 单选框 无校验"-->
              <el-form-item :label="item.attrName" v-if="item.interControl == '5'  && item.isnotFlg == '1'" :prop="'addDataList.' + index + '.ext3'" style="margin-top:20px;">
                <el-radio-group v-model="item.ext3">
                  <el-radio :validate-event="false" v-for="i in radioData" :key="i.item_no" :label="i.item_no">{{i.show_name}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <!-- 客户 -->
            <el-form-item label="适用标识" prop='biaoShi' style="margin-top:20px;">
              <el-radio-group :disabled="disRadio" v-model="addFrom.biaoShi" @change="radioChange">
                <el-radio :label="1">通用</el-radio>
                <el-radio :label="0">非通用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="erJiKehu" label="一级货主" prop='primaryCustomerCode' :rules="[
            { required: true, message: '一级货主不能为空', trigger: 'blur' },
          ]" style="margin-top:20px;">
              <el-select filterable :disabled="disSelectKh" v-model="addFrom.primaryCustomerCode" @change="primaryCustomerCodeChange" :validate-event="false" placeholder="请选择" style="width:210px;">
                <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="erJiKehu" label="二级货主" prop='suoShuKeHu' :rules="[
            { required: true, message: '二级货主不能为空', trigger: 'blur' },
          ]" style="margin-top:20px;">
              <el-select filterable :disabled="disSelectKh" v-model="addFrom.suoShuKeHu" @change="keHuChange" :validate-event="false" placeholder="请选择" style="width:210px;">
                <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="disKehu" label="所属客户" prop='suoShuKeHu' style="margin-top:20px;">
              <el-select filterable :disabled="disSelectKh" v-model="addFrom.suoShuKeHu" @change="keHuChange" :validate-event="false" placeholder="请选择" style="width:210px;">
                <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <div style="margin:20px 0 0 190px;" v-if="jieTiShow">
              <el-table size="mini" border bordersize="mini" ref="tableList" :data="tableList" style="width:403px;font-size:13px;" :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" :header-cell-style="{background:'#F5F5F5',color:'black'}">
                <el-table-column prop="ladderType" label="阶梯" width="60px"></el-table-column>
                <el-table-column prop="startDays" label="开始天数" width="100px"></el-table-column>
                <el-table-column prop="endDays" label="结束天数" width="100px"></el-table-column>
                <el-table-column prop="ladderUnitPrice" label="单价(元/吨·天)" width="142px"></el-table-column>
              </el-table>
            </div>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="seeDialog = false" size='mini'>关 闭</el-button>
        </span>
      </el-dialog>
    </el-tabs>
  </div>
</template>
<script>
import {
  getSheetListBySysModel, // tab数据
  getCostDataList, // 列表查询
  getCostPageData, // 计费规则页面新增、编辑页面变量字段接口
  saveCostDataAdd, // 新增/修改
  seeGroupType, // 字典表
  deleteCostData, // 删除
  getQueryCusterData, // 客户
  getOverdueFeeLadderList
} from '@/api/platform-settlement'
import { zidian } from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import store from '@/store'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00PB001', '000P00PB002', '000P00PB003',
        '000P00PB004', '000P00PB005', '000P00PB006'],
      activeName: 'first',
      editableTabs: [],
      tableDate: [],
      tableHeardArr: [],
      editableTabsValue: '',
      title: '',
      h: '500px',
      total: 0,
      searchFrom1: {
        default_flg: '',
        default_code: '',
        productType_value: '',
        pageNo: 1,
        pageSize: 10
      },
      searchFrom2: {
        primaryCustomerCode: ''
      },
      feeId: '',
      tabId: '',
      // 新增
      addLoading: false,
      changeLoading: false,
      addDialog: false,
      addFrom: {
        customerName: '', // 客户名称
        goodsType: '', // 货物类型
        contractNo: '', // 合同编号
        effectiveDate: '', // 生效日期
        validDate: '', // 有效日期
        addDataList: [], // 新增修改动态表单
        modularIds: [],
        modularNames: [],
        suoShuKeHu: '', // 所属客户
        suoShuKeHuName: '', // name值
        biaoShi: 1,
        primaryCustomerCode: ''
      },
      codeOptions: [], // 下拉框数据
      codeOptions2: [],
      checkData: [], // 复选框数据
      changeBtnShow: false,
      addBtnShow: false,
      rules: {
        customerName: [
          { required: true, message: '客户名称不能为空', trigger: 'change' }
        ],
        goodsType: [
          { required: true, message: '获取类型不能为空', trigger: 'change' }
        ],
        suoShuKeHu: [
          { required: true, message: '所属客户不能为空', trigger: 'blur' }
        ],
        effectiveDate: [
          { required: true, message: '生效日期不能为空', trigger: 'blur' }
        ],
        validDate: [
          { required: true, message: '有效日期不能为空', trigger: 'blur' }
        ],
        biaoShi: [
          { required: true, message: '请选择适用标识', trigger: 'change' }
        ]
      },
      currentRow: '',
      xuanzhongArr: [],
      currentXQ: '',
      seleName: '', // 下拉框name值
      seleName2: '',
      changeId: '',
      checkName: '', // 多选框name值
      // 复选框数组
      checkDataArr: [],
      checkarr: [],
      checkedFlg: false,
      keHuOptions: [], // 所属客户下拉框
      disKehu: false,
      TypesOptions: [
        { id: '', name: '全部' },
        { id: '1', name: '通用' },
        { id: '0', name: '非通用' }
      ],
      HwOptions: [],
      disEdit: false,
      disRadio: false,
      disSelectKh: false,
      tableList: [],
      // 一级货主标识
      primaryCustomerFlag: false,
      erJiKehu: false,
      jieTiShow: false,
      tableName: '',
      seeDialog: false,
      ext1Show: '',
      radioData: [],
      radioJiaoyan: '',
      panku: true,
      PKdanwei: ''
    }
  },
  mounted () {
    // let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - 310) + 'px'
    console.log(this.h, 'this.h')
  },
  created () {
    this.getSheetListBySysModel()
    this.getQueryCusterData()

    this.btnFlg = getBtn(this.btnIdArr, '/smpCost/smpCangChu')
  },
  watch: {
    ext1Show: {
      handler () {
        this.zidians()
      }
    }
  },
  methods: {
    radioChagejiaoyan (val, item) {
      console.log(val, item)
      item.ext2 = this.radioData[val - 1].show_name
      // if (val == 1) {
      //   item.ext2 = '按次'
      // } else if (val == 2) {
      //   item.ext2 = '按吨'
      // } else {
      //   item.ext2 = '按件'
      // }
      this.radioJiaoyan = val
      this.$forceUpdate()
    },
    // 货物类型
    zidians () {
      console.log(this.ext1Show)
      zidian({
        groupNo: this.ext1Show == '3' ? 'fee_jc_product_type' : 'fee_product_type'
      })
        .then((res) => {
          this.HwOptions = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    radioChange (val) {
      if (val == 0 && this.primaryCustomerFlag == true) {
        this.erJiKehu = true
        this.disKehu = false
      } else if (val == 0) {
        this.disKehu = true
        this.erJiKehu = false
      } else {
        this.addFrom.primaryCustomerCode = ''
        this.addFrom.primaryCustomerName = ''
        this.addFrom.suoShuKeHu = ''
        this.addFrom.suoShuKeHuName = ''
        this.disKehu = false
        this.erJiKehu = false
      }
    },
    // 获取tab页数据
    getSheetListBySysModel () {
      getSheetListBySysModel({
        sysModel: '2'
      }).then(res => {
        this.editableTabs = res
        this.editableTabsValue = (this.editableTabs[0].id).toString()
        this.tabId = this.editableTabs[0].id
        this.ext1Show = this.editableTabs[0].ext1
        // if (this.editableTabs[0].ext1 == '1') {
        //   this.ext1Show = 1
        // } else if(this.editableTabs[0].ext1 == '3') {
        //   this.ext1Show = 3
        // }
        this.getListData()
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 点击tab
    handleClick (tab, event) {
      console.log(tab, 'tab')
      this.feeId = tab.name
      this.tableDate = []
      this.tableHeardArr = []
      this.searchFrom1 = {
        default_flg: '',
        default_code: '',
        productType_value: '',
        pageNo: 1,
        pageSize: 10
      }
      this.searchFrom2.primaryCustomerCode = ''
      this.editableTabs.forEach(item => {
        if (this.feeId == item.id) {
          this.ext1Show = item.ext1
          this.getListData()

          // if (item.ext1 == '1') {
          //   this.ext1Show = true
          // } else {
          //   this.ext1Show = false
          //   this.getListData()
          // }
        }
      })
    },
    // 获取列表数据
    getListData () {
      if (this.ext1Show == '1') {
        getCostDataList({
          sysModel: '2',
          feeId: this.feeId || this.tabId,
          ...this.searchFrom1,
          ...this.searchFrom2
        }).then(res => {
          this.tableDate = res.dataList.list
          this.tableHeardArr = res.titleList
          this.total = res.dataList.total
          this.xuanzhongArr = []
        }).catch(err => {
          DonMessage.error(err.message)
        })
      } else {
        getCostDataList({
          sysModel: '2',
          feeId: this.feeId || this.tabId,
          ...this.searchFrom1
        }).then(res => {
          this.tableDate = res.dataList.list
          this.tableHeardArr = res.titleList
          this.total = res.dataList.total
          this.xuanzhongArr = []
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom1.pageSize = val
      this.getListData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom1.pageNo = val
      this.getListData()
    },
    // 查询
    searchClick () {
      this.getListData()
    },
    // 重置
    resetClick () {
      this.searchFrom1 = {
        default_flg: '',
        default_code: '',
        productType_value: '',
        pageNo: 1,
        pageSize: 10
      }
      this.searchFrom2.primaryCustomerCode = ''
      this.getListData()
    },
    // 新增、编辑页面变量字段接口
    getCostPageData (val) {
      this.primaryCustomerFlag = false
      this.jieTiShow = false
      getCostPageData({
        sysModel: '2',
        feeId: this.feeId || this.tabId
      }).then(res => {
        this.addFrom.addDataList = res
        for (let value in this.addFrom.addDataList) {
          this.$set(this.addFrom, value, [])
        }
        this.addFrom.addDataList.forEach((item, index) => {
          if (item.attrStandard == 'primaryCustomerFlag_value') {
            this.primaryCustomerFlag = true
            return
          }
          if (item.attrStandard == 'ladderFeeFlag_value') {
            this.jieTiShow = true
            this.tableList = [{
              ladderType: 1,
              startDays: '1',
              endDays: '',
              ladderUnitPrice: ''
            }]
            return
          }
          if (item.interControl == '2' || item.interControl == '4' || item.interControl == '5') {
            if (item.dsourceFlg == '1') {
              if (item.isnotFlg == '0') {
                this.$axios({
                  url: item.dataSource,
                  method: 'post',
                  data: {},
                  headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: 'Bearer ' + store.getUser().access_token
                  }
                }).then(response => {
                  var res = response.data
                  if (item.interControl == '2') {
                    this.addFrom.addDataList[index].codeOptions = res
                    this.$forceUpdate()
                  }
                  if (item.interControl == '4') {
                    this.checkData = res
                  }
                })
                  .catch(error => {
                    DonMessage.error(error.message)
                  })
              } else {
                this.$axios({
                  url: item.dataSource,
                  method: 'post',
                  data: {},
                  headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: 'Bearer ' + store.getUser().access_token
                  }
                }).then(response => {
                  var res = response.data
                  if (item.interControl == '2') {
                    this.addFrom.addDataList[index].codeOptions2 = res
                    this.$forceUpdate()
                  }
                  if (item.interControl == '4') {
                    this.checkData = res
                  }
                })
                  .catch(error => {
                    DonMessage.error(error.message)
                  })
              }
            } else {
              // 有校验下拉框数据
              if (item.isnotFlg == '0') {
                // 获取新增下拉框复选框数据
                seeGroupType({
                  groupNo: item.dataSource // 获取编码
                }).then(res => {
                  if (item.interControl == '2') {
                    this.addFrom.addDataList[index].codeOptions = res
                    this.$forceUpdate()
                  }
                  if (item.interControl == '4') {
                    this.checkData = res
                  }
                  if (item.interControl == '5') {
                    this.radioData = res
                  }
                }).catch(err => {
                  DonMessage.error(err.message)
                })
              } else if (item.isnotFlg == '1') {
                // 获取新增下拉框复选框数据
                seeGroupType({
                  groupNo: item.dataSource // 获取编码
                }).then(res => {
                  if (item.interControl == '2') {
                    this.addFrom.addDataList[index].codeOptions2 = res
                    this.$forceUpdate() // 强制刷新
                  }
                  if (item.interControl == '4') {
                    this.checkData = res
                  }
                }).catch(err => {
                  DonMessage.error(err.message)
                })
              }
            }
          }
        })
        let str = ''
        if (val != null || val != undefined || val != '') {
          this.addFrom.addDataList.forEach((item, index) => {
            if (item.ext3 == undefined) {
              item.ext3 = ''
            }
            if (item.interControl == '4') {
              this.checkDataArr = (val[item.attrStandard.substring(0, item.attrStandard.length - 6)] || '').split(',')
              this.addFrom.modularIds = (val[item.attrStandard] || '').split(',')
            } else {
              str = item.attrStandard
              item.ext3 = val[str]
            }
          })
        }
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    keHuChange (val) {
      // 同时获取车队下拉框的valu和lable值
      this.keHuOptions.forEach((item, index) => {
        if (item.itemNo == val) {
          this.addFrom.suoShuKeHu = item.itemNo
          this.addFrom.suoShuKeHuName = item.showName
        }
      })
    },
    primaryCustomerCodeChange (val) {
      this.keHuOptions.forEach((item, index) => {
        if (item.itemNo == val) {
          this.addFrom.primaryCustomerCode = item.itemNo
          this.$set(this.addFrom, 'primaryCustomerName', item.showName)
        }
      })
    },
    // 点击新增按钮
    addBtnClick () {
      this.addDialog = true
      this.title = '添加计费规则'
      this.addBtnShow = true
      this.changeBtnShow = false
      this.addFrom = {
        customerName: '', // 客户名称
        goodsType: '', // 货物类型
        contractNo: '', // 合同编号
        effectiveDate: '', // 生效日期
        validDate: '', // 有效日期
        addDataList: [], // 新增修改动态表单
        biaoShi: 1
      }
      this.disEdit = false
      this.disKehu = false
      this.erJiKehu = false
      this.disRadio = false
      this.disSelectKh = false
      this.getCostPageData('')
      this.getQueryCusterData()
    },
    // 下拉框值改变时
    selectChange (id) {
      // 下拉框name值问题
      this.addFrom.addDataList.forEach((item, index) => {
        if (item.interControl == '2' && item.id == id) {
          this.addFrom.addDataList[index].codeOptions.forEach((a) => {
            if (item.ext3 == a.item_no) {
              this.seleName = a.show_name
            }
          })
          item.ext2 = this.seleName
        }
      })
    },
    // 不校验
    selectChange2 (id) {
      this.addFrom.addDataList.forEach((item, index) => {
        if (item.interControl == '2' && item.id == id) {
          this.addFrom.addDataList[index].codeOptions2.forEach((a) => {
            if (item.ext3 == a.item_no) {
              this.seleName = a.show_name
            }
          })
          item.ext2 = this.seleName2
        }
      })
    },
    // 去除数组的空字符串
    trimSpace (array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] == '' || array[i] == null || typeof (array[i]) == 'undefined') {
          array.splice(i, 1)
          i = i - 1
        }
      }
      return array
    },
    // 复选框的值改变时
    checkChange (i, e) {
      console.log(i, e)
      // 同时获取复选框的value和label值
      this.addFrom.modularIds = []
      this.addFrom.modularNames = this.checkDataArr
      console.log(this.checkDataArr)
      this.trimSpace(this.addFrom.modularNames)
      this.addFrom.addDataList.forEach((item, index) => {
        if (item.interControl == '4') {
          item.ext2 = this.checkDataArr.toString()
          this.addFrom.modularIds = []
          this.checkData.forEach((a, index) => {
            if (this.checkDataArr.indexOf(a.showName) != -1) {
              this.addFrom.modularIds.push(a.itemNo)
            } else {
              this.addFrom.modularIds.splice(a.itemNo, 1)
            }
          })
        }
      })
    },
    // 新增保存
    addSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // const a = this.addFrom.addDataList.some(item => item.attrStandard == 'inDoorPrice_value' && item.ext3 == undefined)
          // const b = this.addFrom.addDataList.some(item => item.attrStandard == 'outDoorPrice_value' && item.ext3 == undefined)
          // console.log(a, b)
          // if (a && b) {
          //   console.log('2323')
          //   this.$message({ message: '请至少填写一项单价信息' })
          //   return
          // }
          const hascarInPrice = this.addFrom.addDataList.some(item => item.attrStandard == 'carInPrice_value' && item.ext3 == undefined)
          const trainInPrice = this.addFrom.addDataList.some(item => item.attrStandard == 'trainInPrice_value' && item.ext3 == undefined)
          const shipInPrice = this.addFrom.addDataList.some(item => item.attrStandard == 'shipInPrice_value' && item.ext3 == undefined)

          // const hascarInPrice0 = this.addFrom.addDataList.some(item => item.attrStandard == 'carInPrice_value' && item.ext3 == '0')
          // const trainInPrice0 = this.addFrom.addDataList.some(item => item.attrStandard == 'trainInPrice_value' && item.ext3 == '0')
          // const shipInPrice0 = this.addFrom.addDataList.some(item => item.attrStandard == 'shipInPrice_value' && item.ext3 == '0')
          if (hascarInPrice && trainInPrice && shipInPrice) {
            this.$message({ message: '请至少填写一项单价信息', type: 'error' })
            return
          }
          // if (hascarInPrice0 || trainInPrice0 || shipInPrice0) {
          //   this.$message({ message: '单价不能为0', type: 'error' })
          //   return
          // }
          let feeId = this.feeId
          let keHuCode1 = this.addFrom.suoShuKeHu || ''
          let keHuName = ''
          let primaryCustomerCode = this.addFrom.primaryCustomerCode || ''
          let primaryCustomerName = ''
          // 同时获取下拉框的valu和lable值
          this.keHuOptions.forEach((item, index) => {
            if (this.addFrom.suoShuKeHu == item.itemNo) {
              keHuName = item.showName
            }
            if (this.addFrom.primaryCustomerCode == item.itemNo) {
              primaryCustomerName = item.showName
            }
          })
          if (feeId == '' || feeId == undefined || feeId == null) {
            feeId = this.tabId
          }
          let name = '{"feeId":"' + feeId + '", "sysModel":"' + 2 + '","default_sdate":"' + this.addFrom.effectiveDate + '","default_edate":"' + this.addFrom.validDate + '","default_cno":"' + this.addFrom.contractNo + '","default_cname":"' + keHuName + '","default_code":"' + keHuCode1 + '","default_flg":"' + this.addFrom.biaoShi + '","primary_customer_code":"' + primaryCustomerCode + '","primary_customer_name":"' + primaryCustomerName + '",'
          this.addFrom.addDataList.forEach((item, index) => {
            if (index != '0') {
              name += ','
            }
            let test1 = ''
            if (item.ext3 == null || item.ext3 == undefined) {
              // 错误处理
              test1 = ''
            } else {
              test1 = item.ext3
            }
            var test2 = ''
            // 等于2  下拉框
            if (item.attributeFlg == '2' || item.attributeFlg == '4') {
              test2 = item.attrStandard.substring(0, item.attrStandard.length - 8)
            } else {
              test2 = item.attrStandard.substring(0, item.attrStandard.length - 6)
            }
            // 等于4  复选框
            if (item.interControl == '4' && this.addFrom.modularIds != undefined) {
              let fuXuanKuangIdStr = this.addFrom.modularIds.toString()
              name += '"' + item.attrStandard + '":"' + fuXuanKuangIdStr + '"'
            } else {
              if (item.attrStandard == 'primaryCustomerFlag_value' || item.attrStandard == 'ladderFeeFlag_value') {
                name += '"' + item.attrStandard + '":"' + test1 + 1 + '"'
              } else {
                name += '"' + item.attrStandard + '":"' + test1 + '"'
              }
            }
            if (item.ext2 != '' && item.ext2 != null && item.ext2 != undefined && (item.interControl == '2' || item.interControl == '4' || item.interControl == '5')) {
              name += ',"' + test2 + '":"' + item.ext2 + '"'
            }
            if (index == this.addFrom.addDataList.length - 1) {
              name += '}'
            }
          })
          if (this.jieTiShow == true) {
            this.$set(this.tableList[this.tableList.length - 1], 'remark', '1')
            let tableListData = JSON.stringify(this.tableList)
            let flagB = this.tableList.every(item => item.endDays != '')
            let flagC = this.tableList.some(item => item.endDays < item.startDays)
            if (!flagB) {
              this.$message.error('请先输入结束天数')
            }
            if (flagC) {
              this.$message.error('结束天数必须大于等于开始天数')
            }
            if (flagB && !flagC) {
              this.saveCostDataAddB(name, tableListData)
            }
          } else {
            this.saveCostDataAdd(name)
          }
        } else {
          return false
        }
      })
    },
    // 点击主表选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.currentXQ = 1
      this.getCostPageData(row)
      this.checkChange(this.checkDataArr)
      this.addFrom.suoShuKeHu = row.default_code // 所属客户
      this.addFrom.primaryCustomerCode = row.primary_customer_code
      // 适用标识
      this.addFrom.biaoShi = row.default_flg
      this.changeId = row.id
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击修改按钮
    changeBtnClick () {
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        this.addDialog = true
        this.title = '修改计费规则'
        this.addBtnShow = false
        this.addFrom.modularIds = []
        this.changeBtnShow = true
        this.disEdit = true
        this.disRadio = true
        this.disSelectKh = true
        console.log(this.xuanzhongArr)
        this.getCostPageData(this.xuanzhongArr)
        this.getQueryCusterData()
        if (this.xuanzhongArr.ladderFeeFlag_value / 1 == 1) {
          this.getOverdueFeeLadderList()
        }
        this.addFrom.biaoShi = this.xuanzhongArr.default_flg / 1
        if (this.xuanzhongArr.default_flg / 1 == 0 && this.xuanzhongArr.primaryCustomerFlag_value / 1 == 1) {
          this.erJiKehu = true
          this.disKehu = false
          this.addFrom.primaryCustomerCode = this.xuanzhongArr.primary_customer_code
          this.addFrom.suoShuKeHu = this.xuanzhongArr.default_code // 所属客户
        } else if (this.xuanzhongArr.default_flg / 1 == 0) {
          this.disKehu = true
          this.erJiKehu = false
          this.addFrom.suoShuKeHu = this.xuanzhongArr.default_code // 所属客户
        } else {
          this.disKehu = false
          this.erJiKehu = false
        }
      }
    },
    // 修改确定
    changeSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const hascarInPrice = this.addFrom.addDataList.some(item => item.attrStandard == 'carInPrice_value' && item.ext3 == undefined)
          const trainInPrice = this.addFrom.addDataList.some(item => item.attrStandard == 'trainInPrice_value' && item.ext3 == undefined)
          const shipInPrice = this.addFrom.addDataList.some(item => item.attrStandard == 'shipInPrice_value' && item.ext3 == undefined)

          // const hascarInPrice0 = this.addFrom.addDataList.some(item => item.attrStandard == 'carInPrice_value' && item.ext3 == '0')
          // const trainInPrice0 = this.addFrom.addDataList.some(item => item.attrStandard == 'trainInPrice_value' && item.ext3 == '0')
          // const shipInPrice0 = this.addFrom.addDataList.some(item => item.attrStandard == 'shipInPrice_value' && item.ext3 == '0')
          // console.log(hascarInPrice0, trainInPrice0, shipInPrice0)
          // console.log(hascarInPrice0 && trainInPrice0 && shipInPrice0)
          if (hascarInPrice && trainInPrice && shipInPrice) {
            this.$message({ message: '请至少填写一项单价信息', type: 'error' })
            return
          }
          // if (hascarInPrice0 || trainInPrice0 || shipInPrice0) {
          //   this.$message({ message: '单价不能为0', type: 'error' })
          //   return
          // }
          let feeId = this.feeId
          let fuXuanKuangIdStr = this.addFrom.modularIds
          let keHuCode = this.addFrom.suoShuKeHu
          let keHuName = ''
          let primaryCustomerCode = this.addFrom.primaryCustomerCode || ''
          let primaryCustomerName = ''
          // 同时获取下拉框的valu和lable值
          this.keHuOptions.forEach((item, index) => {
            if (this.addFrom.suoShuKeHu == item.itemNo) {
              keHuName = item.showName
            }
            if (this.addFrom.primaryCustomerCode == item.itemNo) {
              primaryCustomerName = item.showName
            }
          })
          if (feeId == '' || feeId == undefined || feeId == null) {
            feeId = this.tabId
          }
          let name = ''
          name = '{"feeId":"' + feeId + '", "sysModel":"' + 2 + '","default_sdate":"' + this.addFrom.effectiveDate + '","default_edate":"' + this.addFrom.validDate + '","default_cno":"' + this.addFrom.contractNo + '","id":"' + this.changeId + '","default_cname":"' + keHuName + '","default_code":"' + keHuCode + '","default_flg":"' + this.addFrom.biaoShi + '","primary_customer_code":"' + primaryCustomerCode + '","primary_customer_name":"' + primaryCustomerName + '",'
          this.addFrom.addDataList.forEach((item, index) => {
            if (index != '0') {
              name += ','
            }
            let test1 = ''
            if (item.ext3 == null || item.ext3 == undefined) {
              // 错误处理

              test1 = ''
            } else {
              test1 = item.ext3
            }
            var test2 = ''
            if (item.attributeFlg == '2' || item.attributeFlg == '4') {
              test2 = item.attrStandard.substring(0, item.attrStandard.length - 8)
            } else {
              test2 = item.attrStandard.substring(0, item.attrStandard.length - 6)
            }
            // 等于4  复选框
            if (item.interControl == '4' && fuXuanKuangIdStr != undefined) {
              name += '"' + item.attrStandard + '":"' + fuXuanKuangIdStr.toString() + '"'
            } else {
              name += '"' + item.attrStandard + '":"' + test1 + '"'
            }
            if (item.ext2 != '' && item.ext2 != null && item.ext2 != undefined && (item.interControl == '2' || item.interControl == '4' || item.interControl == '5')) {
              name += ',"' + test2 + '":"' + item.ext2 + '"'
            }
            if (index == this.addFrom.addDataList.length - 1) {
              name += '}'
            }
          })
          console.log(name)
          if (this.jieTiShow == true) {
            this.$set(this.tableList[this.tableList.length - 1], 'remark', '1')
            let tableListData = JSON.stringify(this.tableList)
            let flagB = this.tableList.every(item => item.endDays != '')
            let flagC = this.tableList.some(item => item.endDays < item.startDays)
            if (!flagB) {
              this.$message.error('请先输入结束天数')
            }
            if (flagC) {
              this.$message.error('结束天数必须大于等于开始天数')
            }
            if (flagB && !flagC) {
              this.saveCostDataAddB(name, tableListData)
            }
          } else {
            this.saveCostDataAdd(name)
          }
        } else {
          return false
        }
      })
    },
    saveCostDataAdd (name) {
      if (this.addBtnShow == true) {
        this.addLoading = true
      } else {
        this.changeLoading = true
      }
      saveCostDataAdd({
        params: name
      }).then(res => {
        this.$message.success('成功！')
        if (this.addBtnShow == true) {
          this.addLoading = false
        } else {
          this.changeLoading = false
        }
        this.getListData()
        this.addDialog = false
      }).catch(err => {
        if (this.addBtnShow == true) {
          this.addLoading = false
        } else {
          this.changeLoading = false
        }
        this.$message.error(err.message)
      })
    },
    saveCostDataAddB (name, tableListData) {
      if (this.addBtnShow == true) {
        this.addLoading = true
      } else {
        this.changeLoading = true
      }
      saveCostDataAdd({
        params: name,
        ladderList: tableListData
      }).then(res => {
        this.$message.success('成功！')
        if (this.addBtnShow == true) {
          this.addLoading = false
        } else {
          this.changeLoading = false
        }
        this.getListData()
        this.addDialog = false
      }).catch(err => {
        if (this.addBtnShow == true) {
          this.addLoading = false
        } else {
          this.changeLoading = false
        }
        this.$message.error(err.message)
      })
    },
    // 新增取消
    addSpuClose (formName) {
      this.$refs[formName].resetFields()
      this.addFrom.contractNo = ''
      this.checkDataArr = []
      this.addFrom.suoShuKeHu = ''
      this.addFrom.suoShuKeHuName = ''
      this.addDialog = false
      this.tableList = []
    },
    // 删除
    delBtnClick () {
      console.log(this.editableTabsValue)
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        this.$confirm('删除后无法计费及结算，是否确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            deleteCostData({
              sysModel: '2',
              feeId: this.feeId || this.tabId,
              id: this.xuanzhongArr.id
            }).then(res => {
              this.$message.success('删除成功！')
              this.getListData()
            }).catch(err => {
              this.$message.error(err.message)
            })
          })
          .catch(() => { })
      }
    },
    // 点击添加费率
    jieTiAdd () {
      let obj = {}
      obj.ladderType = ''
      obj.startDays = (this.tableList[this.tableList.length - 1].endDays / 1) + 1
      obj.endDays = ''
      obj.ladderUnitPrice = ''
      let flagA = this.tableList.every(item => item.endDays != '')
      if (!flagA) {
        this.$message.error('请先输入结束天数')
        return
      }
      if (flagA) {
        this.tableList.push(obj)
      }
      if (this.tableList.length > 5) {
        this.$message.error('最多新增5个费率')
        this.tableList.splice(5, 1)
      }
    },
    // 新增表格删除
    deleteBtn (row, index) {
      this.tableList.splice(index, 1)
      if (index != this.tableList.length) {
        this.tableList[index].startDays = (this.tableList[index - 1].endDays / 1) + 1
        this.tableList[index].ladderType = (this.tableList[index - 1].ladderType / 1) + 1
      }
    },
    // 结束天数输入
    changeEndDays (row, index) {
      // 下一条的开始天数 = 当前结束天数 + 1
      if (row.endDays == '') {
        this.tableList[index + 1].startDays = ''
      } else {
        row.ladderType = index + 1
        if (index != this.tableList.length - 1) {
          this.tableList[index + 1].startDays = (row.endDays / 1) + 1
        }
        if (row.endDays < row.startDays) {
          this.$message.error('结束天数必须大于等于开始天数')
        }
      }
    },
    getOverdueFeeLadderList () {
      getOverdueFeeLadderList({
        feeId: this.feeId || this.tabId,
        feeFId: this.changeId
      }).then(res => {
        this.tableList = []
        res.forEach(item => {
          let obj = {
            ladderType: item.ladderType,
            startDays: item.startDays,
            endDays: item.endDays,
            ladderUnitPrice: item.ladderUnitPrice
          }
          this.tableList.push(obj)
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击查看
    seeBtnClick () {
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        this.seeDialog = true
        this.addFrom.modularIds = []
        this.disEdit = true
        this.disRadio = true
        this.disSelectKh = true
        this.getCostPageData(this.xuanzhongArr)
        this.getQueryCusterData()
        if (this.xuanzhongArr.ladderFeeFlag_value / 1 == 1) {
          this.getOverdueFeeLadderList()
        }
        this.addFrom.biaoShi = this.xuanzhongArr.default_flg / 1
        if (this.xuanzhongArr.default_flg / 1 == 0 && this.xuanzhongArr.primaryCustomerFlag_value / 1 == 1) {
          this.erJiKehu = true
          this.disKehu = false
          this.addFrom.primaryCustomerCode = this.xuanzhongArr.primary_customer_code
          this.addFrom.suoShuKeHu = this.xuanzhongArr.default_code // 所属客户
        } else if (this.xuanzhongArr.default_flg / 1 == 0) {
          this.disKehu = true
          this.erJiKehu = false
          this.addFrom.suoShuKeHu = this.xuanzhongArr.default_code // 所属客户
        } else {
          this.disKehu = false
          this.erJiKehu = false
        }
      }
    }
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width: 150px;
  text-align: center;
}
/deep/ .is-active {
  color: #0c46a2;
}
.inpBox {
  margin: 10px 0 0 -30px;
}
/deep/ .inpBox .el-range-editor--mini .el-input__inner {
  width: 150px;
}
.searchBtnBox {
  margin-top: 10px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 280px;
  background-color: #fff;
}
.searchBtnBox {
  margin-top: 10px;
}
 /deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
